/** A new version of the app is waiting (service worker); applied only when the person taps "Neu laden". */
export const update = { ready: false, apply: () => {} };
